module.exports = __webpack_public_path__ + "img/watch-tutorials.1eb9e469.png";